import cls from "pages/MainPage/ui/MainPage.module.scss";
import { classNames } from "shared/lib/classNames/classNames";
import Title from "shared/ui/Title/Title";
import Paragraph, { ParagraphTheme } from "shared/ui/Paragraph/Paragraph";
import DotGridBackground from "../../shared/ui/DotGridBackground";

const TermsPage = () => {
    return (
        <div id="mainPage" className={cls.indexPage}>
            <div className={cls.gridBg}>
                <DotGridBackground />
            </div>

            <section className={classNames("page-section", {}, [cls.indexPage__about])}>
                <div className={classNames("container", "container__main")}>
                    <div className={cls.About}>
                        <div className={cls.termsContent}>
                            <Title className={cls.indexPage__title} sentences={["Terms & Conditions"]} />

                            <Paragraph className={cls.mt24}>
                                By downloading or using the Bloxsy: Steal Games app, you agree to these Terms and
                                Conditions automatically. Please take the time to read them carefully before using
                                the app.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                You are not permitted to copy, alter, or reproduce the app, any portion of it, or
                                any trademarks associated with it. Attempting to extract the app's source code,
                                translate it into other languages, or create derivative versions is strictly
                                forbidden. The app, including all related intellectual property rights—such as
                                copyrights, trademarks, and database rights—remains the exclusive property of SBS
                                CONSULTING STRATEGIES LTD. SBS CONSULTING STRATEGIES LTD is committed to maintaining
                                the app’s usefulness and functionality. As such, we reserve the right to modify the
                                app or introduce fees for certain features or services at any time. Should we decide
                                to charge for any services, we will provide clear information about what those fees
                                cover.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                The Bloxsy: Steal Games app stores and processes personal data that you provide in
                                order to operate the Service. You are responsible for securing your device and
                                ensuring proper access to the app. We strongly advise against jailbreaking or
                                rooting your device, as this may compromise its security, expose it to malware, and
                                potentially cause the app to stop functioning properly.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Third-Party Services The app makes use of third-party services, which have their own
                                Terms and Conditions. You can refer to the policies of these services here:
                            </Paragraph>

                            <ul className={cls.termsList}>
                                <li>Google Play Services</li>
                                <li>Google Analytics for Firebase</li>
                                <li>Firebase Crashlytics</li>
                            </ul>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Limitation of Liability
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Please note that SBS CONSULTING STRATEGIES LTD will not be held responsible for
                                certain issues. Some app features require an active internet connection (via Wi-Fi
                                or a mobile network). If you do not have access to a connection or exceed your data
                                allowance, the app may not work as intended, and we cannot accept liability in such
                                cases. When using the app outside a Wi-Fi area, your mobile provider’s terms and
                                conditions will still apply. You may incur data charges, including roaming fees if
                                outside your region or country. By using the app, you take full responsibility for
                                such charges. If you’re not the account holder for the device, we assume you have
                                received appropriate permission from the account holder.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Similarly, we are not responsible for how you use the app. For example, if your
                                device is not charged and the app becomes unavailable, that is solely your
                                responsibility.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                While we aim to ensure the app is always up-to-date and fully operational, certain
                                features rely on third-party services and data. SBS CONSULTING STRATEGIES LTD is not
                                liable for any direct or indirect losses resulting from reliance on the app’s data
                                or performance. App Updates and Availability
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We may update the app occasionally to improve functionality or address issues. The
                                app is currently available on Android, and system requirements may change. You are
                                expected to download updates to continue using the app. We cannot guarantee that all
                                updates will be compatible with every Android device or OS version
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We also reserve the right to discontinue the app at any time, without prior notice.
                                Upon termination:
                            </Paragraph>

                            <ul className={cls.termsList}>
                                <li>All rights and licenses granted to you under these Terms will end</li>
                                <li>You must stop using the app and, if necessary, remove it from your device</li>
                                <li>Firebase Crashlytics</li>
                            </ul>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>Changes to These Terms</Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We may revise these Terms and Conditions from time to time. It is your
                                responsibility to review this page periodically for updates. Any changes will be
                                posted here and will take effect immediately.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>Effective Date: 2025-04-07</Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Contact Us
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                If you have any questions or feedback about these Terms and Conditions, feel free to
                                reach out to us at: snehapatelwi@gmail.com
                            </Paragraph>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TermsPage;
